import { withContent } from '@bubbletea/core';
import { IContent } from '../../../../../types';
import { FeatureItem, FeatureDescription, IconWrapper, LearnMoreLink } from './styles';
import { CheckIcon } from '../../../../UI/Icons';
import sendEvent from '../../../../../utils/sendEvent';

interface IFeatureProps {
  context: IContent;
  text: string;
  learnMore?: string;
  color?: string;
  isFreeTrialFeature?: boolean;
}

const Feature = ({ context, text, learnMore, color, isFreeTrialFeature = false }: IFeatureProps) => {
  const { googlesheet } = context;
  const { global } = googlesheet;

  const learnMoreEventDetails = {
    location: 'available plans',
    category: 'interaction',
    locationPosition: 4,
    action: 'rocksmith 2014 bonus : learn more',
  };
  return (
    <FeatureItem color={color}>
      <IconWrapper isFreeTrialFeature={isFreeTrialFeature} color={color}>
        <CheckIcon />
      </IconWrapper>
      <FeatureDescription
        dangerouslySetInnerHTML={{ __html: text }}
        isFreeTrialFeature={isFreeTrialFeature}
        color={color}
      />
      {learnMore && (
        <LearnMoreLink href={learnMore} onClick={() => sendEvent(learnMoreEventDetails)}>
          {global.learnMore}
        </LearnMoreLink>
      )}
    </FeatureItem>
  );
};

export default withContent(Feature);
